// extracted by mini-css-extract-plugin
export var centerText = "_8k-8";
export var container = "_8k-0";
export var doughnutContainer = "_8k-7";
export var legend = "_8k-a";
export var legendItemColorDisplay = "_8k-b";
export var legendItemLabel = "_8k-d";
export var legendItemValue = "_8k-c";
export var lg = "_8k-5";
export var maxWidth = "_8k-9";
export var md = "_8k-4";
export var responsive = "_8k-6";
export var sm = "_8k-3";
export var xs = "_8k-2";
export var xxs = "_8k-1";